import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useFeatureAuth } from '../hooks/authorization'
import { FEATURES } from '../utils/constants/features.constants'

interface RequireAdminProps {
  children: React.ReactNode
}

const RequireAdmin: React.FC<RequireAdminProps> = ({ children }) => {
  const { t } = useTranslation()
  const isAuthorised = useFeatureAuth(FEATURES.ADMIN_PANEL)

  if (!isAuthorised) {
    return (
      <div className="pt-10 text-center">
        <h2 className="text-2xl font-bold">{t('admin.unauthorizedTitle')}</h2>
        <Link to="/">
          <span className="inline-block mt-10 mx-auto px-6 py-3 rounded bg-while text-primary hover:bg-gray-200 border border-primary">
            {t('admin.goBackHome')}
          </span>
        </Link>
      </div>
    )
  }

  return <>{children}</>
}

export default RequireAdmin
